import { Badge, Card, Col, Divider, Image, Row, Typography } from 'antd'
import { KeyboardIcon, MouseIcon } from '../../../assets/icons'

export const ScreenShotComponent = (props) => {
    const { screenshotsData = {}, token = '' } = props
    const { Title, Text } = Typography
    let data = Object.keys(screenshotsData?.data || {})
    return (
        <>
            {/* <InfiniteScroll
                dataLength={
                    state?.filteredNotesData?.length > 0
                        ? state?.filteredNotesData?.length
                        : 0
                }
                next={fetchMoreScreenShots}
                hasMore={isNext}
                style={{
                    overflow: 'inherit',
                }}
            > */}
            {data?.map((date) => {
                let subData = Object.keys(screenshotsData?.data[date])
                return subData.map((subTime) => (
                    <>
                        <Row
                            style={{
                                marginTop: '18px',
                            }}
                        >
                            {/* <Col span={3}>
                                <Row>
                                   
                                </Row>
                                <Row>
                                    
                                </Row>
                            </Col> */}
                            <Divider orientation="left"><Row>  <Text>{date}</Text><Title level={5}>{subTime}</Title></Row></Divider>
                            <Col span={24}>
                                <Image.PreviewGroup
                                    preview={{
                                        onChange: () => { },
                                    }}
                                >
                                    <Row gutter={[30, 30]}>
                                        {screenshotsData?.data[date][subTime]
                                            ?.length > 0 &&
                                            screenshotsData?.data[date][
                                                subTime
                                            ].map((item) => (
                                                <Col
                                                    xs={24}
                                                    sm={24}
                                                    md={12}
                                                    lg={12}
                                                    xl={8}
                                                    xxl={8}
                                                >
                                                    <Card
                                                        hoverable
                                                        bordered={false}
                                                        styles={{
                                                            body: {
                                                                padding: 10,
                                                            },
                                                        }}
                                                        cover={
                                                            <Image
                                                                height={120}
                                                                src={
                                                                    item?.url.includes(
                                                                        'https'
                                                                    )
                                                                        ? item?.url
                                                                        : 'https://pms-bucket123.s3.amazonaws.com/locationImage_1717501529.jpg'
                                                                }
                                                                style={{
                                                                    objectFit:
                                                                        'cover',
                                                                }}
                                                                preview={
                                                                    item?.url.includes(
                                                                        'https'
                                                                    )
                                                                        ? true
                                                                        : false
                                                                }
                                                                onClick={() => {
                                                                    if (
                                                                        !item?.url.includes(
                                                                            'https'
                                                                        )
                                                                    ) {
                                                                        const parsedData =
                                                                            JSON.parse(
                                                                                item?.url
                                                                            )

                                                                        // Extract the values
                                                                        const lat =
                                                                            parsedData?.lat
                                                                        const lng =
                                                                            parsedData?.long // changed 'long' to 'lng' to avoid conflict with reserved keyword

                                                                        const url = `https://www.google.com/maps?q=${lat},${lng}`
                                                                        // Open the URL in a new tab
                                                                        window.open(
                                                                            url,
                                                                            '_blank'
                                                                        )
                                                                    }
                                                                }}
                                                            />
                                                        }
                                                    >
                                                        <Row
                                                            align={'middle'}
                                                            style={{
                                                                columnGap:
                                                                    '8px',
                                                            }}
                                                        >
                                                            <Title
                                                                level={5}
                                                                style={{
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                {new Date(
                                                                    item?.createdAt
                                                                ).toLocaleString(
                                                                    'default',
                                                                    {
                                                                        hour: 'numeric',
                                                                        minute: '2-digit',
                                                                    }
                                                                )}
                                                            </Title>
                                                            {!item?.url.includes(
                                                                'https'
                                                            ) && (
                                                                    <Badge
                                                                        count={`${JSON.parse(
                                                                            item?.url
                                                                        )?.type
                                                                            } Time`}
                                                                        color={
                                                                            JSON.parse(
                                                                                item?.url
                                                                            )
                                                                                ?.type ===
                                                                                'start'
                                                                                ? 'hsla(155, 54%, 46%, 0.16)'
                                                                                : 'hsla(11, 100%, 59%, 0.16)'
                                                                        }
                                                                        style={{
                                                                            minWidth:
                                                                                '30px',
                                                                            cursor: 'auto',
                                                                            borderRadius:
                                                                                '6px',
                                                                            display:
                                                                                'flex',
                                                                            alignItems:
                                                                                'center',
                                                                            color:
                                                                                JSON.parse(
                                                                                    item?.url
                                                                                )
                                                                                    ?.type ===
                                                                                    'start'
                                                                                    ? token
                                                                                        .colorPalette
                                                                                        .iconColor
                                                                                        .tertiary
                                                                                    : token
                                                                                        .colorPalette
                                                                                        .iconColor
                                                                                        .quaternary,
                                                                            padding:
                                                                                '12px 8px',
                                                                            fontWeight: 700,
                                                                            textTransform:
                                                                                'uppercase',
                                                                        }}
                                                                    />
                                                                )}
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            {item?.url.includes(
                                                                'https'
                                                            ) ? (
                                                                <Row>
                                                                    <div
                                                                        style={{
                                                                            height: '16px',
                                                                            width: '16px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        <KeyboardIcon />
                                                                    </div>
                                                                    <span>
                                                                        Keystrokes
                                                                        / min
                                                                        &nbsp;
                                                                    </span>
                                                                </Row>
                                                            ) : (
                                                                <span>
                                                                    Latitude
                                                                    &nbsp;
                                                                </span>
                                                            )}

                                                            <span
                                                                style={{
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {item?.url.includes(
                                                                    'https'
                                                                )
                                                                    ? item?.total_mouse_movements
                                                                        ? parseInt(
                                                                            item?.total_keypresses
                                                                        )
                                                                        : 0
                                                                    : JSON.parse(
                                                                        item?.url
                                                                    )?.lat}
                                                            </span>
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            {item?.url.includes(
                                                                'https'
                                                            ) ? (
                                                                <Row>
                                                                    <div
                                                                        style={{
                                                                            height: '16px',
                                                                            width: '16px',
                                                                            marginRight:
                                                                                '10px',
                                                                        }}
                                                                    >
                                                                        <MouseIcon />
                                                                    </div>
                                                                    <span>
                                                                        Mouse
                                                                        moments
                                                                        / min
                                                                        &nbsp;
                                                                    </span>
                                                                </Row>
                                                            ) : (
                                                                <span>
                                                                    Longitude
                                                                    &nbsp;
                                                                </span>
                                                            )}
                                                            <span
                                                                style={{
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {item?.url.includes(
                                                                    'https'
                                                                )
                                                                    ? item?.total_mouse_movements
                                                                        ? parseInt(
                                                                            item?.total_mouse_movements
                                                                        )
                                                                        : 0
                                                                    : JSON.parse(
                                                                        item?.url
                                                                    )?.long}
                                                            </span>
                                                        </Row>
                                                        <Row
                                                            style={{
                                                                width: '100%',
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                            justify={
                                                                'space-between'
                                                            }
                                                        >
                                                            <Col span={24}>
                                                                <Divider
                                                                    dashed
                                                                    style={{
                                                                        margin: '8px 0',
                                                                    }}
                                                                />
                                                                <Row>
                                                                    <Text>
                                                                        App:
                                                                    </Text>
                                                                    <Text
                                                                        strong
                                                                        // type="success"
                                                                        style={{
                                                                            marginLeft: 5,
                                                                        }}
                                                                    >
                                                                        {item
                                                                            ?.activeWindow
                                                                            ?.owner
                                                                            ?.name ||
                                                                            'Unknown App'}
                                                                    </Text>
                                                                </Row>
                                                                {/* <Row>
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                '12px',
                                                                        }}
                                                                    >
                                                                        {item
                                                                            ?.activeWindow
                                                                            ?.title ||
                                                                            'No Title'}
                                                                    </Text>
                                                                </Row> */}
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            ))}
                                    </Row>
                                </Image.PreviewGroup>
                            </Col>
                        </Row>
                        <Divider />
                    </>
                ))
            })}
            {/* </InfiniteScroll> */}
        </>
    )
}
